'use strict';

/**
 * @author Maxim Seredkin
 * @param {$uibModal} $modal
 * @param {SupportStageRestService} SupportStageRestService
 * @return {*}
 */
export default ['$uibModal', 'SupportStageRestService',
    function($modal, SupportStageRestService) {

        return {
            edit: edit,
            create: create,
            api: SupportStageRestService,
        };

        /**
         * Создание
         * @return {*}
         */
        function create() {
            return $modal.open({
                template: require('../view/support-stage-modal-create.html'),
                controller: 'SupportStageModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    supportStage: function() {
                        return {};
                    },
                },
            });
        }

        /**
         * Редактирование
         * @param {*} item
         * @return {*}
         */
        function edit(item) {
            return $modal.open({
                template: require('../view/support-stage-modal-create.html'),
                controller: 'SupportStageModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    supportStage: function() {
                        return item;
                    },
                },
            });
        }
    }];
